import React from 'react';
import { FuelIcon, FuelTypography } from '@frete.com/fuel-react';
import theme from '@frete.com/fuel-foundation/fretebras/theme.json';
import {
  PulsePropsInterface,
  SizeLabelType,
  MapColorsType,
} from './PulseTypes';
import * as Styled from './PulseStyles';

function Pulse({ label, description, icon, inactive }: PulsePropsInterface) {
  let nameSizeLabel = `body-${label.size}` as SizeLabelType;
  const mapColors: MapColorsType = {
    black: theme.color.icon.neutral.strong,
    gray: theme.color.icon.neutral.weak,
    green: theme.color.text.success.default,
  };

  if (label.size === 'sm') {
    nameSizeLabel = 'caption';
  }

  return (
    <Styled.Pulse
      isPulse={icon.isPulse}
      color={mapColors[icon.color]}
      hasFuelIcon={!!icon.name}
      inactive={inactive}
    >
      {icon.name && (
        <Styled.IconWrapper>
          <FuelIcon name={icon.name} size="tiny" />
        </Styled.IconWrapper>
      )}
      <FuelTypography
        size={nameSizeLabel}
        color={label.color}
        weight={label.weight}
      >
        {label.text}
      </FuelTypography>
      {description && (
        <FuelTypography
          tag="p"
          size="caption"
          color="neutral-default"
          weight="medium"
          spacingTop={8}
        >
          {description}
        </FuelTypography>
      )}
    </Styled.Pulse>
  );
}

export default Pulse;
